import * as React from "react";
import {Badge} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function ({ numVariants, icon='cart-shopping', tooltip='Num Variants', ...props }) {
    return <Badge badgeContent={numVariants} color="primary">
        <IconSeeker
            icon={icon}
            tooltip={tooltip}
            sx={{ ml: 1, mr: 1, ...props?.sx }}
            {...props}
        />
    </Badge>
}